<template>
  <div class="sirui-modal-search">
    <el-form
      label-position="right"
      :label-width="labelWidth"
      :model="query"
      ref="queryFrom"
      @submit.native.prevent
    >
      <el-row :gutter="10">
        <template v-for="(column, index) in columns">
          <el-col
            :key="column.prop"
            :span="9"
            :style="{
              display: expandAll ? 'block' : expand ? 'block' : index < 2 ? 'block' : 'none',
            }"
          >
            <!--开始时间-->
            <template v-if="column.type == 'startDaterangePicker'">
              <el-form-item
                :label="column.name"
                :prop="column.prop"
                :class="{ propClass: column.name.trim().length > propLength }"
              >
                <el-date-picker
                  clearable
                  style="width: 100%"
                  v-model="query[column.prop]"
                  type="date"
                  :placeholder="column.placeholder || $t('search.choose')"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerStartOptions"
                ></el-date-picker>
              </el-form-item>
            </template>

            <!--结束时间-->
            <template v-else-if="column.type == 'endDaterangePicker'">
              <el-form-item
                :label="column.name"
                :prop="column.prop"
                :class="{ propClass: column.name.trim().length > propLength }"
              >
                <el-date-picker
                  clearable
                  style="width: 100%"
                  v-model="query[column.prop]"
                  type="date"
                  :placeholder="column.placeholder || $t('search.choose')"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerEndOptions"
                ></el-date-picker>
              </el-form-item>
            </template>

            <el-form-item
              v-else
              :label="column.name"
              :prop="column.prop"
              :class="{ propClass: column.name.trim().length > propLength }"
            >
              <!--输入框-->
              <el-input
                v-if="column.type == 'input'"
                v-model="query[column.prop]"
                :maxlength="column.maxlength || 32"
                :placeholder="column.placeholder || $t('search.input')"
                :disabled="column.disabled || false"
                clearable
                @keyup.enter="
                  () => {
                    console.log('你好');
                  }
                "
              >
                <!-- 是否可以多选输入 -->
                <SearchMultipleValue
                  v-if="column.isNeedMultipleValue"
                  :maxlength="column.maxlength"
                  :defaultValue="query[column.prop]"
                  slot="suffix"
                  :ref="'SearchMultipleValue' + column.prop"
                  @setMultiple="(val) => setMultiple(val, column.prop)"
                ></SearchMultipleValue>
              </el-input>
              <!--单选框-->
              <el-select
                v-if="column.type == 'select'"
                v-model="query[column.prop]"
                :placeholder="column.placeholder || $t('search.choose')"
                clearable
                @change="change(query[column.prop])"
              >
                <el-option
                  v-for="item in column.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!--多选框-->
              <el-select
                v-if="column.type == 'selectMultiple'"
                multiple
                clearable
                v-model="query[column.prop]"
                :placeholder="column.placeholder || $t('search.choose')"
              >
                <el-option
                  v-for="(item, index) in column.options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <!--日期-->
              <el-date-picker
                clearable
                style="width: 100%"
                v-if="column.type == 'date'"
                v-model="query[column.prop]"
                type="date"
                :placeholder="column.placeholder || $t('search.choose')"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              ></el-date-picker>
              <!--日期时间-->
              <el-date-picker
                clearable
                style="width: 100%"
                v-if="column.type == 'datetime'"
                v-model="query[column.prop]"
                type="datetime"
                :placeholder="column.placeholder || $t('search.choose')"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerTimeOptions"
              ></el-date-picker>
              <!--日期范围-->
              <el-date-picker
                clearable
                style="width: 100%"
                v-if="column.type == 'daterange'"
                v-model="query[column.prop]"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('search.to')"
                :start-placeholder="$t('search.start')"
                :end-placeholder="$t('search.end')"
              ></el-date-picker>
              <!--下拉树-->
              <tree-select
                style="width: 100%"
                ref="treeSelect"
                v-if="column.type == 'treeSelect'"
                :model="column.prop"
                :apiUrl="column.apiUrl"
                :apiData="column.apiData"
                :clearable="column.clearable || true"
                :isName="column.isName"
                :multiple="column.multiple || false"
                :returnType="column.returnType || ''"
                :currentValue="column.currentValue || null"
                :normalizerFlag="column.normalizerFlag || true"
                @setSearchModal="setSearchModal"
              ></tree-select>
            </el-form-item>
          </el-col>
          <el-col
            class="search-btns"
            :span="columns.length == 1 ? 14 : 6"
            :key="index"
            v-if="index == 1 || columns.length == 1"
          >
            <el-button type="primary" v-on:click="search($event)">
              <span class="footer-button">{{ $t('search.search') }}</span>
            </el-button>
            <el-button @click="resetForm">
              <span class="footer-button">{{ $t('search.reset') }}</span>
            </el-button>
            <a class="search-expand" v-if="columns.length > 2" @click="toggle">{{ expandText }}</a>
            <i
              v-if="columns.length > 2"
              style="cursor: pointer; font-size: 12px; color: #6299fe; margin-left: -3px"
              :class="icon"
            ></i>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import SearchMultipleValue from '@/components/SearchMultipleValue';
  import treeSelect from '@/components/form-item/tree-select';

  export default {
    components: {
      SearchMultipleValue,
      treeSelect,
    },
    data() {
      return {
        icon: 'el-icon-arrow-down',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        },
        pickerStartOptions: {
          disabledDate: (time) => {
            let endDate = null;
            this.columns.forEach((item) => {
              if (item.type == 'endDaterangePicker') {
                endDate = this.query[item.prop];
              }
            });
            if (endDate) {
              return time.getTime() > new Date(endDate).getTime();
            }
          },
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            let startDate = null;
            this.columns.forEach((item) => {
              if (item.type == 'startDaterangePicker') {
                startDate = this.query[item.prop];
              }
            });
            if (startDate) {
              return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
            }
          },
        },
        pickerTimeOptions: {},
        expand: false,
      };
    },
    props: {
      query: {
        type: Object,
        default: () => {},
      },
      /**
       * columns筛选参数：
       * name:'名称'
       * prop:'字段名字'
       * type'编辑类型',['inpput','select','selectMultiple','date','datetime']
       * options:当编辑类型是select时的初始数据。
       * maxlength:可输入的最大长度
       */
      columns: {
        type: Array,
        default: () => [],
      },
      labelWidth: {
        type: String,
        default: '90px',
      },
      // 展开全部的
      expandAll: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      expandText: {
        get: function () {
          return this.$t('search.spread');
        },
        set: function () {
          if (!this.expand) {
            return this.$t('search.spread');
          } else {
            return this.$t('search.packUp');
          }
        },
      },
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 6 : 14;
      },
    },
    watch: {
      query: {
        handler(newValue) {
          this.$emit('changeQuery', newValue);
        },
        deep: true,
      },
    },
    methods: {
      change(val) {
        console.log('val', val);
      },
      resetForm() {
        if (this.$refs.treeSelect && this.$refs.treeSelect[0]) {
          this.$refs.treeSelect[0].resetClick();
        }
        this.$refs.queryFrom.resetFields();
        this.$emit('resetBtnClick');
      },
      search() {
        this.$emit('searchBtnClick', { query: this.query });
      },
      toggle() {
        this.expand = !this.expand;
        if (!this.expand) {
          this.icon = 'el-icon-arrow-down';
        } else {
          this.icon = 'el-icon-arrow-up';
        }
      },
      //将表格里的多值赋值到查询条件里
      setMultiple(value, prop) {
        this.query[prop] = value;
      },
      setSearchModal(model, row) {
        console.log(model, row, this.query, '??');
        this.query[model] = row;
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;

  .sirui-modal-search .el-form-item {
    margin-bottom: 12px;
  }
  .search-btns {
    text-align: right;
  }
  .search-expand {
    cursor: pointer;
    margin: 0 0 0 1px;
    font-size: 12px;
    color: $maintheme;
  }
  .sirui-search {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    padding-bottom: 8px;
  }
  .el-button {
    border-radius: 2px;
    border: 1px solid #6299fe;
    color: #6299fe;
    margin-left: 3px;
  }
  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
    color: #fff;
  }
</style>
